// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.topup-package .v-stepper {\n  box-shadow: none;\n}\n.topup-package .v-stepper__header {\n  box-shadow: none;\n}\n@media screen and (max-width: 600px) {\n.v-stepper__header {\n    flex-wrap: nowrap;\n}\n}\n", ""]);
// Exports
module.exports = exports;
